import { Truck, Shield, Clock, Phone } from "lucide-react";

export default function Services() {
  const services = [
    {
      title: "Servicio de Entrega Rápido y Confiable",
      description: "Llevamos tus productos donde los necesites, con puntualidad, cuidado y eficiencia.",
      icon: Truck
    },
    {
      title: "Productos Certificados, Calidad Garantizada",
      description: "Todos nuestros productos cumplen con los más altos estándares de calidad, seguridad y eficacia.",
      icon: Shield
    },
    {
      title: "Productos de Alta Demanda",
      description: "Respaldados por la confianza de miles de profesionales y centros de salud.",
      icon: Clock
    },
    {
      title: "Asesoría Técnica",
      description: "Consultoría experta para seleccionar equipamiento.",
      icon: Phone
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Nuestros Servicios</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluciones completas más allá de la venta
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

          <div className="space-y-8">
            {services.map((s, i) => (
              <div key={i} className="flex items-start space-x-4 bg-white p-6 rounded-xl shadow-sm border">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold">{s.title}</h3>
                  <p className="text-gray-600">{s.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl border flex flex-col justify-between h-full">
            <h3 className="text-2xl font-bold text-center mb-6">¿Por qué elegirnos?</h3>

            <ul className="flex flex-col justify-between h-full">
              {[
                "Más de 23 años de experiencia en el sector médico",
                "Marcas reconocidas y autorizadas",
                "Asesoría técnica en cada etapa del proceso de compra",
                "Presencia activa en hospitales, clínicas y centros de salud",
                "Respuesta rápida y atención personalizada vía WhatsApp Business",
              ].map((t, i) => (
                <li key={i} className="flex items-center space-x-3">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
